// @ts-check
'use_strict';

import { CheckoutViewLoader } from './CheckoutViewLoader';
import { CartEstimatorView } from './CartEstimatorView';

let shipping_initialized = false;
// Initialize.
export function init() {
    if (!shipping_initialized && document.readyState === 'interactive') {
        shipping_initialized = true;
        if (document.getElementById('checkout_steps')) {
            (() => new CheckoutViewLoader())();
        } else if (document.getElementById('js-cart-shipping-estimator-opener-link')) {
            (() => new CartEstimatorView())();
        }
    }
}
